import React from 'react';

const withProps = (getProps) => (Component) => {
  const WithProps = (props) => <Component {...props} {...getProps(props)} />;

  WithProps.displayName = `WithProps(${Component.displayName || Component.name})`;

  return WithProps;
};

export default withProps;


// WEBPACK FOOTER //
// ./src/utils/withProps.js